const localRegexp = new RegExp("^/([a-zA-Z]{2})/([a-zA-Z]{2})");

export const DEFAULT_LOCALE = { country: "se", language: "en" };

export const getLanguageAndLocaleFromUrl = () => {
  const res = localRegexp.exec(window?.location?.pathname);

  if (res && (res?.length ?? 0) > 2) {
    return {
      country: res[1],
      language: res[2],
    };
  }

  return null;
};

export const getLanguageLocal = (language: string, market: string) =>
  `${language}-${market.toUpperCase()}`;
